<template>
    <el-dialog
            class="assign-dialog"
            :visible.sync="visible"
            :title="$t('assign.replaceuser')"
            :close-on-click-modal="isClose"
            :close-on-press-escape="isClose"
            :show-close="true"
            width="1100px"
    >
        <div class="el-dialog__header_cus" slot="title">
            {{ $t("assign.replaceuser") }}
        </div>
        <div class="mod-joylearning__replaceuser">
            <el-form
                    label-position="left"
                    :model="dataForm"
                    @keyup.enter.native="getDataList()"
            >
                <div class="top_message">
                    <!-- 排期信息显示 -->
                    <el-row :gutter="18">
                        <el-col :span="6">
                            <!-- 排期编号 -->
                            <el-form-item
                                    :label="$t('registe.offeringcode')+ ':'"
                                    prop="offeringNo"
                            >
                                {{ dataofferinginfo.offeringNo }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <!-- 课程代码 -->
                            <el-form-item :label="$t('couse.coursecode')+ ':'" prop="courseCode">
                                {{ dataofferinginfo.courseCode }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <!-- 课程名称 -->
                            <el-tooltip :content="dataofferinginfo.courseNameCn" placement="top" effect="light">

                                <el-form-item :label="$t('registe.coursename')+ ':'"  prop="courseNameCn">
                                    <p class="longText">{{ dataofferinginfo.courseNameCn }}</p>
                                </el-form-item>
                            </el-tooltip>
                            <!--                            <el-form-item
                                                                :label="$t('registe.coursename')+ ':'"
                                                                prop="courseNameCn"
                                                        >
                                                            {{ dataofferinginfo.courseNameCn }}
                                                        </el-form-item>-->
                        </el-col>
                        <el-col :span="6">
                            <!-- 排期名称 -->
                            <el-form-item
                                    :label="$t('registe.offeringname')+ ':'"
                                    prop="offeringName"
                            >
                                {{ dataofferinginfo.offeringName }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="18">
                        <el-col :span="6">
                            <!-- 场地 -->
                            <el-form-item :label="$t('registe.place1')+ ':'" prop="siteName">
                                {{ dataofferinginfo.siteName }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <!-- 价格 -->
                            <el-form-item label="排期价格(元):" prop="coursePrice">
                                {{ formatMoney(dataofferinginfo.coursePrice) }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <!-- 培训师 -->
                            <el-form-item :label="$t('registe.trainer')+ ':'" prop="trainerName">
                                {{ dataofferinginfo.trainerName }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <!-- 开始时间 -->
                            <el-form-item :label="$t('registe.startdate')+ ':'" prop="startdate">
                                {{ dataofferinginfo.startdate }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="18">
                        <el-col :span="6">
                            <!-- 结束时间 -->
                            <el-form-item :label="$t('registe.enddate')+ ':'" prop="enddate">
                                {{ dataofferinginfo.enddate }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-row class="margb10" :gutter="18">
                    <el-col :span="6">
                        <!-- 姓名 -->
                        <el-form-item :label="$t('registe.username')+ ':'">
                            <el-input
                                    v-model="dataForm.userName"
                                    :placeholder="$t('请输入姓名')"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="9">
                        <!-- 岗位 -->
                        <el-form-item :label="$t('registe.positionname') + ':'">
                            <!-- <el-select v-model="dataForm.positionName"
                                       multiple
                                       collapse-tags
                                       :placeholder="$t('cert.select')"
                                       clearable>
                              <el-option v-for="(item,index) in positionList"
                                         :key="index"
                                         :label="item.name"
                                         :value="item.positionId">
                              </el-option>
                            </el-select> -->
                            <el-select
                                    style="width: 335px!important;"
                                    filterable
                                    multiple
                                    collapse-tags
                                    v-model="dataForm.positionName"
                                    placeholder="请选择职位"
                                    @change="jobChange"
                            >
                                <el-option
                                        v-for="(item, index) in jobCodeArr"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.code"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" style="padding-left:25px;margin-top: 20px; text-align: left">
                        <el-checkbox
                                style="jobCheckedAlready?{'color':'red';}:{'color':'green';}"
                                v-model="jobCheckedAlready"
                                :disabled="
                dataForm.positionName.length === 0 && !jobCheckedAlready
              "
                                @change="positionCheckChange"
                        >已选择职位
                        </el-checkbox
                        >
                    </el-col>
                    <!-- 重置 -->
                    <el-col :span="6" class="search-btn" style="text-align: right">
                        <el-button
                                class="el-back info-btn"
                                type="info"
                                :loading="dataListLoading"
                                @click="again"
                        >{{ $t("reset") }}
                        </el-button
                        >
                        <el-button
                                class="primary-btn"
                                type="primary"
                                :loading="dataListLoading"
                                @click="getDataListMerge"
                        >{{ $t("query") }}
                        </el-button
                        >
                    </el-col>
                </el-row>
                <el-row
                        style="
            border: 1px dashed rgba(238, 239, 240, 1);
            margin: 18px auto 24px;
          "
                ></el-row>
                <el-row type="flex" justify="space-between" align="center">
                    <el-col :span="8" v-if="isaccountBalance">
                        <!-- 账户余额-->
                        <!--            <el-form-item :label="$t('assign.accountBalance')"-->
                        <!--                          prop="accountBalance">-->
                        <!--&lt;!&ndash;              {{formatMoney(dataofferinginfo.accountBalance)}}&ndash;&gt;-->
                        <!--              {{dataofferinginfo.accountBalance}}-->
                        <!--            </el-form-item>-->
                        <div style="padding: 6px !important">
                            <div
                                    style="
                  float: left;
                  color: rgba(37, 38, 40, 100);
                  font-size: 14px;
                  text-align: left;
                  padding-top: 2px;
                  font-family: PingFangSC-Regular, sans-serif;
                "
                            >
                                <el-tooltip placement="bottom-start" effect="light">
                                    <div slot="content">
                                        <!--                       勾选替换人员前可用金额等于原用户报名时需付费金额+当前账户可用余额，勾选替换人员后将从可用金额中扣除替换人员所需付费金额。-->
                                        勾选前显示金额=当前账户可用余额+原学员报名时需付费金额，勾选后扣除替换人员所需付费金额。
                                    </div>
                                    <img
                                            style="
                      margin-top: -2px;
                      width: 16px;
                      height: 16px;
                      display: inline-block;
                      vertical-align: middle;
                      margin-right: 4px;
                    "
                                            src="../../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                                            alt=""
                                    />
                                </el-tooltip>
                                <span>可用金额(元)：</span>
                            </div>
                            <div style="float: left">
                                <countTo
                                        :startVal="startVal"
                                        :endVal="endVal"
                                        :duration="1000"
                                        :decimals="2"
                                        class="card-panel-num"
                                ></countTo>
                            </div>
                        </div>
                        <!--            {{$t('assign.idNumber')}}:{{dataForm.positionName}} prefix="可用余额(元)："-->
                    </el-col>
                    <!--分配-->
                    <el-col :span="3" style="text-align: right">
                        <el-button
                                type="primary"
                                :loading="dataListLoading"
                                @click="replace"
                        >{{ $t("registe.change") }}
                        </el-button
                        >
                    </el-col>
                </el-row>
                <!-- <el-row>
                  <div> -->
                <!--          <el-col :span="7" v-if="isaccountBalance">-->
                <!--&lt;!&ndash;            &lt;!&ndash;汇总余额(元)=账户余额(元)+ 欲解冻余额(元)&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;            <el-form-item :label="$t('registe.accountBalance')"&ndash;&gt;-->
                <!--&lt;!&ndash;                          prop="availableBalance">&ndash;&gt;-->
                <!--              <el-form-item :label="$t('registe.accountBalance')"-->
                <!--                            prop="availableBalance">-->
                <!--                 <span slot="label">{{$t('registe.accountBalance')}}-->
                <!--                  <el-tooltip placement="bottom-start" effect="light" >-->
                <!--                    <div slot="content">-->
                <!--&lt;!&ndash;                       勾选替换人员前可用金额等于原用户报名时需付费金额+当前账户可用余额，勾选替换人员后将从可用金额中扣除替换人员所需付费金额。&ndash;&gt;-->
                <!--                       勾选前显示金额=当前账户可用余额+原学员报名时需付费金额，勾选后扣除替换人员所需付费金额。-->
                <!--                    </div>-->
                <!--                    <em class="el-icon-question" style="color: #1C69D3"></em>-->
                <!--                  </el-tooltip>-->
                <!--                </span>-->
                <!--              {{dataofferinginfo.availableBalance}}-->

                <!--            </el-form-item>-->
                <!--          </el-col>-->
                <!-- </div> -->
                <!-- <el-col :span="7" v-if="isaccountBalance">
                    <div style="padding: 6px !important">
                      <div style="float: left; font-size: 20px">
                        <el-tooltip placement="bottom-start" effect="light">
                          <div slot="content">
                            勾选前显示金额=当前账户可用余额+原学员报名时需付费金额，勾选后扣除替换人员所需付费金额。
                          </div>
                          <em class="el-icon-question" style="color: #1c69d3"></em>
                        </el-tooltip>
                        可用金额(元)：
                      </div>

                      <div style="float: left; font-size: 20px">
                        <countTo
                          :startVal="startVal"
                          :endVal="endVal"
                          :duration="1000"
                          :decimals="2"
                          class="card-panel-num"
                        ></countTo>
                      </div>
                    </div>
                  </el-col> -->
                <!--          <el-col :span="5">-->
                <!--            &lt;!&ndash;欲解冻余额(元)&ndash;&gt;-->
                <!--            <el-form-item :label="$t('registe.unfreezeBalance')"-->
                <!--                          prop="unfreezeBalance">-->
                <!--              {{dataofferinginfo.unfreezeBalance}}-->
                <!--            </el-form-item>-->
                <!--          </el-col>-->
                <!--          <el-col :span="5">-->
                <!--            &lt;!&ndash;账户余额(元)&ndash;&gt;-->
                <!--            <el-form-item :label="$t('registe.accountBalance')"-->
                <!--                          prop="accountBalance">-->
                <!--              {{dataofferinginfo.accountBalance}}-->
                <!--            </el-form-item>-->
                <!--          </el-col>-->
                <!-- </el-row> -->
            </el-form>
            <br/>
            <div class="table-user table">
                <el-table
                        :data="dataList"
                        border
                        ref="singleTable"
                        v-loading="dataListLoading"
                        style="width: 100%"
                        class="jySelectionAll"
                        @selection-change="SelectionChange"
                        :row-style="rowStyle"
                        @select="handleSelectionChange"
                >
                    <!-- 选择框 -->
                    <el-table-column
                            type="selection"
                            header-align="center"
                            align="center"
                            width="40"
                            :selectable="checkboxInit"
                    >
                    </el-table-column>
                    <!-- 身份证号 -->
                    <el-table-column
                            prop="userId"
                            v-if="false"
                            :label="$t('assign.idNumber')"
                            width="180"
                            align="center"
                    >
                    </el-table-column>
                    <!-- 用户ID -->
                    <el-table-column
                            prop="userCode"
                            header-align="center"
                            show-overflow-tooltip
                            align="center"
                            :label="$t('offering.resource.trainerId')"
                    >
                    </el-table-column>
                    <!-- 员工号 -->
                    <el-table-column
                            prop="userCardNo"
                            header-align="center"
                            show-overflow-tooltip
                            align="center"
                            :label="$t('trainer.userCardNo')"
                    >
                    </el-table-column>
                    <!-- 姓名 -->
                    <el-table-column
                            prop="userNameCn"
                            :label="$t('registe.username')"
                            width="150"
                            align="center"
                    >
                    </el-table-column>
                    <!-- 身份证号 -->
                    <el-table-column
                            prop="idcardSer"
                            :label="$t('assign.idNumber')"
                            width="180"
                            align="center"
                    >
                    </el-table-column>
                    <!-- 主要职位 -->
                    <el-table-column
                            prop="jobName"
                            :label="$t('assign.positionname')"
                            width="150"
                            show-overflow-tooltip
                            align="center"
                    >
                    </el-table-column>
                    <!-- 兼职职位1 -->
                    <el-table-column
                            prop="partOneJob"
                            :label="$t('assign.parttimejobone')"
                            width="120"
                            show-overflow-tooltip
                            align="center"
                    >
                    </el-table-column>
                    <!-- 兼职职位2 -->
                    <el-table-column
                            prop="partTwoJob"
                            :label="$t('assign.parttimejobtwo')"
                            width="120"
                            show-overflow-tooltip
                            align="center"
                    >
                    </el-table-column>
                    <!-- 兼职职位3 -->
                    <el-table-column
                            prop="partThreeJob"
                            :label="$t('assign.partTimeJobThree')"
                            width="120"
                            show-overflow-tooltip
                            align="center"
                    >
                    </el-table-column>
                    <!-- 兼职职位4 -->
                    <el-table-column
                            prop="partFourJob"
                            :label="$t('assign.partTimeJobFour')"
                            width="120"
                            show-overflow-tooltip
                            align="center"
                    >
                    </el-table-column>
                    <!-- 兼职职位5 -->
                    <el-table-column
                            prop="partFiveJob"
                            :label="$t('assign.partTimeJobFive')"
                            width="120"
                            show-overflow-tooltip
                            align="center"
                    >
                    </el-table-column>
                    <!-- 经销商类型 -->
                    <el-table-column
                            prop="orgTypeNameCn"
                            :label="$t('registe.dotType')"
                            align="center"
                    >
                    </el-table-column>
                </el-table>
            </div>
            <!-- <div
              class="block"
              style="float: right; margin-top: 10px; margin-bottom: 10px"
            > -->
            <el-pagination
                    background
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle"
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
            >
            </el-pagination>
            <!-- </div> -->
        </div>
        <!-- <template slot="footer">
          <div class="dialog-footer"></div>
        </template> -->
        <!-- ******************** 替换页面 新增画面**** :showOfferingDate="listDate"    :close-on-click-modal="false"************************************-->
        <el-dialog
                width="1100px"
                :visible.sync="offeringConditionvalus"
                :close-on-click-modal="false"
                append-to-body
        >
            <showOffering ref="offeringConditionreplace"></showOffering>
        </el-dialog>
        <el-dialog
                class="replaceDialog"
                :title="'确定将学员' + parentData.userName + '替换为'"
                width="700px"
                :visible.sync="isShowReplaceForm"
                :close-on-click-modal="isClose"
                :close-on-press-escape="isClose"
                :append-to-body="true"
                :show-close="false"
                top="8vh"
        >
            <!--<div>-->
            <!--<el-row :gutter="10">-->
            <!--确定将学员 {{this.parentData.userName}} 替换为 {{this.vehicleData.userNameCn}}？-->
            <!--</el-row>-->
            <!--</div>-->
            <div class="el-dialog__header_cus_assign" slot="title">
                <img
                        style="
            width: 16px;
            height: 16px;
            display: inline-block;
            vertical-align: middle;
          "
                        src="../../../../../assets/img/learning/Scheduling/pop_up_title_icon_hint@1x.png"
                        alt=""
                />
                <span
                        style="
            color: rgba(37, 38, 40, 100);
            font-size: 16px;
            text-align: left;
            margin-left: 4px;
            vertical-align: middle;
            height: 22px;
            line-height: 22px;
            font-family: PingFangSC-Medium, sans-serif;
          "
                >替换用户</span
                >
            </div>
            <div>
                <el-row>
                    <el-col :span="10">
                        <el-tag
                                show-overflow-tooltip
                        >
                            {{ vehicleData.userNameCn + "（" + vehicleData.userCode + "）"}}
                            <span
                                    class="tag-reduction"
                                    v-if="vehicleData.isDeduction == '减免'"
                                    style="font-size: 12px"
                            >减免</span
                            ></el-tag
                        >
                    </el-col>
                </el-row>
                <!--        <el-row :gutter="10">-->
                <!--          <div style="text-align:right">-->
                <!--            <el-col :span="22">共1名学员,培训总金额(元):</el-col><el-col :span="2"> <div style="text-align:left">{{paymenttotalmoney}}</div></el-col>-->
                <!--            <el-col :span="22" v-if="isReductiontotalmoney">减免金额(元):</el-col><el-col v-if="isReductiontotalmoney" :span="2"><div style="text-align:left">{{reductiontotalmoney}}</div></el-col>-->
                <!--            <el-col :span="22">支付金额(元):</el-col><el-col :span="2"><div style="text-align:left">{{paymenttotalmoney}}</div></el-col>-->
                <!--            <el-col :span="22">可用金额(元):</el-col><el-col :span="2"><div style="text-align:left">{{dataofferinginfo.availableBalance}}</div></el-col>-->
                <!--          </div>-->
                <!--        </el-row>-->
                <!-- div show-msg-container -->
                <div class="show-msg-container">
                    <el-row :gutter="10" style="margin-bottom: 8px">
                        <el-col :span="12">
                            <el-col :span="8">
                                <div class="msg-label" style="float: right">课程费用(元):</div>
                            </el-col>
                            <el-col :span="10" style="padding-left: 2px; padding-right: 12px">
                                <div
                                        class="msg-value"
                                        style="float: right"
                                        v-if="isReductiontotalmoney"
                                >
                                    {{
                                    this.formatMoney(
                                    Number((paymenttotalmoney + reductiontotalmoney).toFixed(3))
                                    )
                                    }}
                                </div>
                                <div class="msg-value" style="float: right" v-else>
                                    {{ this.formatMoney(Number(paymenttotalmoney.toFixed(3))) }}
                                </div>
                            </el-col>
                        </el-col>
                    </el-row>
                    <el-row
                            :gutter="10"
                            style="margin-bottom: 8px"
                            v-if="isReductiontotalmoney"
                    >
                        <el-col :span="12">
                            <el-col :span="8">
                                <div class="msg-label" style="float: right">减免金额(元):</div>
                            </el-col>
                            <el-col :span="10" style="padding-left: 2px; padding-right: 12px">
                                <div class="msg-value" style="float: right">
                                    {{ this.formatMoney(Number(reductiontotalmoney.toFixed(3))) }}
                                </div>
                            </el-col>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" style="margin-bottom: 8px">
                        <el-col :span="12">
                            <div style="text-align: center">
                                <el-col :span="8">
                                    <div class="msg-label" style="float: right">支付金额(元):</div>
                                </el-col>
                                <el-col :span="10" style="padding-left: 2px; padding-right: 12px">
                                    <div class="msg-value" style="float: right">
                                        {{
                                        this.formatMoney(
                                        Number(
                                        (
                                        paymenttotalmoney
                                        //dataofferinginfo.availableBalance + paymenttotalmoney
                                        ).toFixed(3)
                                        )
                                        )
                                        }}
                                    </div>
                                </el-col>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-col :span="8">
                                <div class="msg-label" style="float: right">可用金额(元):</div>
                            </el-col>
                            <el-col :span="10" style="padding-left: 2px; padding-right: 12px">
                                <div style="float: right" class="msg-value">
                                    {{ this.formatMoney(Number((dataofferinginfo.availableBalance + paymenttotalmoney).toFixed(3))) }}
                                </div>
                            </el-col>
                            <!--          <div style="float:right"><div style="float:left">支付金额(元):</div><div style="float:left">{{paymenttotalmoney}}</div></div>-->
                        </el-col>
                        <el-col :span="12" v-if="dataofferinginfo.availableBalance >= 0">
                            <el-col :span="24">
                                <div class="msg-value msg-spe-value" style="float: right">
                                    {{
                                    this.formatMoney(
                                    Number(dataofferinginfo.availableBalance.toFixed(3))
                                    )
                                    }}
                                </div>
                                <div class="msg-label" style="float: right; margin-right: 5px">
                                    付费后可用余额(元):
                                </div>
                            </el-col>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <el-row
                    justify="space-between"
                    style="
          padding-top: 24px;
          margin-top: 16px;
          border-top: 1px dashed rgba(0, 0, 0, 0.1);
        "
            >
                <!--        <el-col :span="4">&nbsp;</el-col>-->
                <el-col :span="10">&nbsp;</el-col>
                <el-col :span="14" style="text-align: right">
                    <el-button
                            @click="isShowReplaceForm = false"
                            :loading="dataListLoading"
                    >{{ $t("registe.cancel") }}
                    </el-button
                    >
                    <el-button
                            :loading="dataListLoading"
                            type="primary"
                            @click="submitForm()"
                    >{{ $t("registe.submission") }}
                    </el-button
                    >
                </el-col>
            </el-row>
        </el-dialog>
        <el-dialog
                class="one"
                v-if="dialogVisible1"
                :visible.sync="dialogVisible1"
                :close-on-click-modal="true"
                :modal="true"
                :show-close="true"
                :center="true"
                :append-to-body="true"
                width="990px">
            <el-row>
                <el-col :span="24" style="height: 44px; margin: auto; text-align: center; font-weight: 700; font-size: 14px; color: #409EFF">
                    <p>该学员已报名该时段的其他排期，由于时间冲突，操作失败。冲突排期如下：</p>
                </el-col>
            </el-row>
            <br>
            <el-table border :data="errorData" :header-cell-style="{background: '#EBEEF5'}">
                <el-table-column width="141px" label="排期编号" header-align="center" align="center" show-overflow-tooltip prop="offeringNo"></el-table-column>
                <el-table-column width="200px" label="课程名称" header-align="center" align="center" show-overflow-tooltip prop="courseName"></el-table-column>
                <el-table-column width="200px" label="开始时间" header-align="center" align="center" show-overflow-tooltip prop="startDate"></el-table-column>
                <el-table-column width="200px" label="结束时间" header-align="center" align="center" show-overflow-tooltip prop="endDate"></el-table-column>
                <el-table-column width="200px" label="场地" header-align="center" align="center" show-overflow-tooltip prop="siteName"></el-table-column>
            </el-table>
            <br>
            <!-- <span slot="footer" class="dialog-footer">
               <el-button @click="dialogVisible1 = false">取 消</el-button>
               <el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
             </span>-->
        </el-dialog>
    </el-dialog>
</template>

<script>
    import Vue from "vue";
    import mixinViewModule from "@/mixins/view-module";
    import showOffering from "../../offering/offeringcommon/pcShowOfferingDetails/show";
    import countTo from "vue-count-to";

    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                dialogVisible1:false,
                errorData: [],
                // 获取列表信息
                mixinViewModuleOptions: {
                    getDataListURL: "/sys/courseinforela/queryuserdetails",
                    getRegisteredDataListURL:
                        "/learning/offeringregiste/selectRegistrationStaff", // 已报名人数
                    submitReplaceDataListURL: "/learning/offeringregiste/changeUser",
                    traineeRegisteCheck: "/learning/offeringregiste/TraineeRegisteCheck",
                    getfreerulescheckURL: "/learning/rule/freerules/check", //把维度减免接口
                    getqueryReplaceBalanceURL: "/learning/finance/queryReplaceBalance", //替换学员时查询相关余额 /learning/finance/queryReplaceBalance
                    getDataListIsPage: true,
                },
                offeringConditionvalus: false,
                // offeringId: '',
                visible: false,
                dataForm: {
                    userName: "", // 姓名
                    positionName: [], // 岗位
                },
                dataofferinginfo: {
                    registeId: "", // 报名ID
                    offeringId: "", // 排期ID
                    offeringNo: "", // 排期编号
                    courseId: "", // 课程ID
                    courseCode: "", // 课程代码
                    courseNameCn: "", // 课程名称
                    offeringName: "", // 派其名称
                    trainerName: "", // 培训师
                    siteId: "", // 场地ID
                    siteName: "", // 场地名称
                    startdate: "", // 开始时间
                    enddate: "", // 结束时间
                    coursePrice: "", // 价格
                    availableBalance: 0, //汇总金额
                    unfreezeBalance: 0, //欲解冻余额
                    accountBalance: 0, //账户余额
                },
                dataBalance: {
                    availableBalance: 0, //汇总金额
                    unfreezeBalance: 0, //欲解冻余额
                    accountBalance: 0, //账户余额
                },
                isaccountBalance: true, //是否有账户
                availableBalance: 0, // 查询出来的初始的值 汇总金额
                reduction: 0, // 减免人数
                reductiontotalmoney: 0, //减免金额 为排期价格*减免人数
                isReductiontotalmoney: false, //是否显示减免
                paymenttotalmoney: 0, //支付金额 培训总金额
                accountBalance: 0, //还剩账户余额
                parentData: {
                    userName: "",
                    registeId: "",
                    userId: "",
                },
                dataList: [],
                vehicleData: {
                    userNameCn: "",
                }, // 已选人员
                userNameCn: "",
                positionList: [], // 岗位列表
                memberList: [],
                // 等待转圈
                dataListLoading: false,
                isShowReplaceForm: false,
                isClose: true,
                //岗位下拉选择
                jobCodeArr: [],
                jobCheckedAlready: false, // 已选职位
                positionChangeVal: [], // change事件传递过来的已选项
                positionChangeOld: [], // 上次职位的已选项
                positionSelectAlready: [], // 主要职位已选项,
                startVal: 0,
                endVal: 0,
                chooseList: [],
            };
        },
        components: {
            showOffering,
            countTo,
        },
        computed: {},
        created() {
            this.mixinViewModuleOptions.getDataListURL =
                "/sys/courseinforela/queryuserdetails";
            this.mixinViewModuleOptions.getDataListIsPage = true;
            this.getDataList();
            this.queryPosition();
        },
        methods: {
            SelectionChange(val) {
                this.chooseList = val
            },
            rowStyle({row, rowIndex}) {
                if (this.chooseList.includes(row)) {
                    return {'background-color': '#e8f0fa'}
                } else {
                    return {'background-color': '#fff'}
                }
            },
            init() {
                /* eslint-disable */
                // debugger
                this.visible = true;
                this.again();
            },
            // 查询
            getDataListMerge() {
                /* eslint-disable */
                // debugger
                // console.info('222222222222222', this.memberList)
                this.getDataList();
            },
            // 获取数据列表
            getDataList() {
                console.info(this.dataForm);
                let orgId = this.getStorage(this.GLOBAL.USER_DATA).orgId;
                let jobCodes = "";
                for (let i = 0; i < this.dataForm.positionName.length; i++) {
                    if (jobCodes === "") {
                        jobCodes = this.dataForm.positionName[i];
                    } else {
                        jobCodes = jobCodes + "," + this.dataForm.positionName[i];
                    }
                }
                if (this.brandQuery != null || this.brandQuery !== "") {
                    this.dataForm.courseBrand = this.brandQuery + "";
                }
                let newDataForm = JSON.parse(JSON.stringify(this.dataForm));
                if ("regionIds" in newDataForm) {
                    if (newDataForm.regionIds.length === 0) {
                        newDataForm.regionIds = "";
                    } else {
                        newDataForm.regionIds = newDataForm.regionIds.join(",");
                    }
                }
                this.dataListLoading = true;
                this.isClose = false;
                this.$request
                    .get(this.mixinViewModuleOptions.getDataListURL, {
                        order: this.order,
                        orderField: this.orderField,
                        orgId: orgId,
                        jobCodes: jobCodes,
                        page: this.mixinViewModuleOptions.getDataListIsPage
                            ? this.page
                            : null,
                        limit: this.mixinViewModuleOptions.getDataListIsPage
                            ? this.limit
                            : null,
                        ...newDataForm,
                    })
                    .then((res, total, code, data) => {
                        console.warn(data.result);
                        this.dataListLoading = false;
                        this.isClose = true;
                        let resultList = data.data.records;
                        this.dataList = resultList;
                        this.total = this.mixinViewModuleOptions.getDataListIsPage
                            ? parseInt(data.data.total, 10)
                            : 0;
                        // 延迟加载
                        this.$nextTick(() => {
                            this.querSelect();
                        });
                    })
                    .catch(() => {
                        this.dataListLoading = false;
                        this.isClose = true;
                    });
                this.$request
                    .post(this.mixinViewModuleOptions.getRegisteredDataListURL, {
                        offeringId: this.dataofferinginfo.offeringId,
                        courseId: this.dataofferinginfo.courseId,
                    })
                    .then((res, total, code, data) => {
                        this.dataListLoading = false;
                        this.isClose = true;
                        this.memberList = data.data;
                        console.info(
                            "this.registeredDataList----------->>>",
                            this.memberList
                        );
                    })
                    .catch(() => {
                        this.dataListLoading = false;
                        this.isClose = true;
                    });
            },
            getDataListBalance(offeringId, userId) {
                // 根据排期 YIXIAN.ZHU 查询 母店所属金额
                this.$request
                    .get(this.mixinViewModuleOptions.getqueryReplaceBalanceURL, {
                        offeringId: offeringId,
                        userId: userId,
                    })
                    .then((res, total, code, data) => {
                        this.dataListLoading = false;
                        this.isClose = true;
                        // availableBalance:3900,//汇总金额
                        //         unfreezeBalance:100,//欲解冻余额
                        //         accountBalance:3800//账户余额
                        let codes = data.code;
                        if (codes == 2) {
                            //没有账户
                            this.isaccountBalance = false; // 当前经销商未开通账户
                        }
                        if (codes == 1) {
                            //有账户时
                            this.dataofferinginfo.availableBalance = data.data.availableBalance;
                            this.dataofferinginfo.unfreezeBalance = data.data.unfreezeBalance;
                            this.dataofferinginfo.accountBalance = data.data.accountBalance;
                            this.availableBalance = data.data.availableBalance;

                            this.startVal = data.data.availableBalance;
                            this.endVal = data.data.availableBalance;
                        }

                        console.info(
                            "this.registeredDataList----------->>>",
                            this.memberList
                        );
                    })
                    .catch(() => {
                        this.dataListLoading = false;
                        this.isClose = true;
                    });
            },
            // 重置
            again() {
                this.dataForm = {
                    userName: "", // 姓名
                    positionName: "", // 岗位
                };
                this.jobCheckedAlready = false;
                this.positionChangeVal = [];
                this.positionSelectAlready = [];
                this.positionChangeOld = [];
                this.queryPosition();
                this.getDataList();
            },
            // 数据校验
            checkboxInit(row, index) {
                let flag = 1;
                let userId = this.getStorage(this.GLOBAL.USER_DATA).userId;
                for (let i = 0; i < this.memberList.length; i++) {
                    // if (row.userId === this.memberList[i].userId || row.userId === userId) {
                    //   // if (this.memberList[i].approvalStatus !== '40') {
                    //   flag = 0 // 0不可勾选，1可勾选
                    //   // }
                    // }
                    if (row.userId === this.memberList[i].userId) {
                        flag = 0; // 0不可勾选，1可勾选
                    }
                }
                return flag;
            },
            // 替换
            replace() {
                console.info("parent---->>", this.parentData);
                if (
                    this.vehicleData.userNameCn === "" ||
                    this.vehicleData.userNameCn === null ||
                    this.vehicleData.userNameCn === undefined
                ) {
                    this.$message("请选择替换人员");
                } else {
                    // 追加分配金额计算
                    var reduction = 1;
                    var paymenttotalmoney = 0;
                    var isReductiontotalmoney = false;
                    if (this.vehicleData.isDeduction == "减免") {
                        isReductiontotalmoney = true;
                    }
                    paymenttotalmoney = paymenttotalmoney + this.vehicleData.coursePrice;
                    this.isReductiontotalmoney = isReductiontotalmoney;
                    this.reduction = reduction; //减免人数
                    this.reductiontotalmoney =
                        this.reduction * this.dataofferinginfo.coursePrice; //减免金额
                    this.paymenttotalmoney = paymenttotalmoney;
                    this.isShowReplaceForm = true;
                }
                console.info("replaceVehicleData----->>>", this.vehicleData);
            },
            submitForm: function () {
                this.dataListLoading = true;
                this.isClose = false;
                this.vehicleData.registeId = this.parentData.registeId;
                var _this = this;
                // this.updataForm.offeringSignDetailDTOList = this.signData
                _this.$request
                    .post(
                        this.mixinViewModuleOptions.submitReplaceDataListURL,
                        _this.vehicleData
                    )
                    .then((res, total, code, data) => {
                        if (data.code !== 1) {
                            if (data.code == 210) {
                                this.$message({
                                    message: data.msg,
                                    type: "warning",
                                    duration: 2000,
                                });
                            } else {
                                this.$message({
                                    message: data.msg,
                                    type: "error",
                                    duration: 2000,
                                });
                            }
                        } else {
                            if ("操作失败。" === data.msg) {
                                _this.$message({
                                    message: "操作失败。",
                                    type: "error",
                                    duration: 2000,
                                });
                            } else if ("抱歉，学员已报名该时段的其他排期，由于时间冲突，操作失败。" === data.msg) {
                                _this.$message({
                                    message: "抱歉，学员已报名该时段的其他排期，由于时间冲突，操作失败。",
                                    type: "error",
                                    duration: 2000,
                                });
                            }else {
                                _this.$message({
                                    message: _this.$t("prompt.success"),
                                    type: "success",
                                    duration: 500,
                                });
                            }
                        }

                        _this.isShowReplaceForm = false;
                        _this.getDataListMerge();
                        _this.visible = false;
                        _this.$emit("refreshDataList");
                        _this.dataListLoading = false;
                        _this.isClose = true;
                    })
                    .catch(function (error) {
                        _this.dataListLoading = false;
                        _this.isClose = true;
                        console.log(error);
                        // _this.$message.error(_this.$t("errorCode." + json.reason, data.message))
                    });
            },
            // 判断 arrs数组中是否存在row 存在则返回true
            isExistRow: function isExistRow(arrs, row, field) {
                let flag = false;
                arrs.forEach(function (item) {
                    if (row[field] === item[field]) {
                        flag = true;
                    }
                });
                return flag;
            },
            // 勾选演员按钮 (会做验证)
            handleSelectionChange(selection, row) {
                this.dataListLoading = true;
                this.isClose = false;
                if (this.$refs.singleTable.selection.length > 1) {
                    this.$refs.singleTable.clearSelection();
                    this.$refs.singleTable.toggleRowSelection(row);
                }

                if (!this.isaccountBalance) {
                    console.info("不能勾选" + this.isaccountBalance);
                    this.$message({
                        message: "未找到匹配规则，请联系系统管理员进行规则维护",
                        type: "error",
                    });
                    this.dataListLoading = false;
                    this.isClose = true;
                    this.$refs.singleTable.selection.forEach(function (item, index, arr) {
                        console.info("******", item);
                        if (item === row) {
                            arr.splice(index, 1);
                        }
                    });
                }
                // 判断当前点击的是打钩还是取消打钩 true 则是打勾
                let isSelected = this.isExistRow(selection, row, "userId");
                if (isSelected) {
                    //是否可以勾选
                    var istrue = false;
                    var ischeck = false; // 是否减免
                    this.$request
                        .post(this.mixinViewModuleOptions.getfreerulescheckURL, {
                            offeringId: this.dataofferinginfo.offeringId,
                            userId: row.userId,
                        })
                        .then((res, total, code, data) => {
                            let isOk = data.msg;
                            if (isOk == "success") {
                                let datac = data.data;
                                if (datac) {
                                    console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>减免1");
                                    ischeck = true; // 减免
                                }
                            }
                            // ********************************************************start20210628
                            if (ischeck) {
                                // this.dataofferinginfo.availableBalance=this.availableBalance-0
                                //是否减免
                                Vue.set(row, "isDeduction", "减免");
                                //扣款金额
                                Vue.set(row, "coursePrice", 0);
                                if (this.availableBalance - 0 < 0) {
                                    istrue = false;
                                } else {
                                    istrue = true;
                                }

                                //汇总金额
                                //Vue.set(row, "availableBalance", this.dataofferinginfo.ccountBalance)
                                console.info(
                                    this.dataofferinginfo.availableBalance +
                                    "=====================>",
                                    row.isDeduction
                                );
                            } else {
                                // 不减免时
                                console.info(
                                    "不减免金额剩余" +
                                    (this.availableBalance - this.dataofferinginfo.coursePrice)
                                );
                                if (
                                    this.availableBalance - this.dataofferinginfo.coursePrice <
                                    0
                                ) {
                                    console.info(
                                        this.dataofferinginfo.availableBalance +
                                        "========钱不够=============>",
                                        row.isDeduction
                                    );
                                    istrue = false;
                                } else {
                                    istrue = true;
                                    //是否减免
                                    Vue.set(row, "isDeduction", "不减免");
                                    //扣款金额
                                    Vue.set(row, "coursePrice", this.dataofferinginfo.coursePrice);
                                    //汇总金额
                                    //Vue.set(row, "汇总金额", this.dataofferinginfo.ccountBalance)
                                    console.info(
                                        this.dataofferinginfo.availableBalance +
                                        "=====================>",
                                        row.isDeduction
                                    );
                                }
                            }
                            if (istrue) {
                                console.info(
                                    "能勾选>>>>>>>>>>>>" + this.isExistRow(selection, row, "userId")
                                );
                                if (!this.isExistRow(selection, row, "userId")) {
                                    // this.vehicleData.push(row)
                                    this.vehicleData = row;
                                }
                                // this.dataListLoading = false
                                // this.isClose = true
                            } else {
                                console.info("不能勾选");
                                let arr = this.chooseList;
                                for (let i = 0; i < arr.length; i++) {
                                    if (arr[i].userId === row.userId) {
                                        arr.splice(i, 1)
                                    }
                                }
                                this.chooseList = arr;
                                this.$message({
                                    message: "账户余额不足，请及时预存资金",
                                    type: "error",
                                });
                                this.dataListLoading = false;
                                this.isClose = true;
                                this.$refs.singleTable.selection.forEach(function (
                                    item,
                                    index,
                                    arr
                                ) {
                                    console.info("******", item);
                                    if (item === row) {
                                        arr.splice(index, 1);
                                    }
                                });
                            }
                            // 勾选
                            if (this.vehicleData !== undefined) {
                                console.log(
                                    this.availableBalance +
                                    ">>>>>>>>>>>>>>>>>>>>>>1   " +
                                    row.coursePrice
                                );
                                this.$request
                                    .post(this.mixinViewModuleOptions.traineeRegisteCheck, {
                                        offeringId: this.dataofferinginfo.offeringId,
                                        type: "20",
                                        registeChangeUserDTOList: [
                                            {
                                                userId: row.userId,
                                                userCode: row.userCode,
                                            },
                                        ],
                                        registeReplaceUserCode: this.parentData.userId
                                    })
                                    .then((res, total, code, data) => {
                                        let isOk = data.msg;
                                        if (istrue && isOk === "OK") {
                                            console.log(
                                                this.availableBalance +
                                                ">>>>>>>>>>>>>>>>>>>>>>2" +
                                                row.coursePrice
                                            );
                                            this.dataofferinginfo.availableBalance = Number(
                                                (this.availableBalance - row.coursePrice).toFixed(3)
                                            );
                                            this.startVal = this.availableBalance;
                                            this.endVal = this.dataofferinginfo.availableBalance;
                                            // 判断 vehicleData 是否有勾选的数据
                                            // if (!this.isExistRow(this.vehicleData, row, 'userId')) {
                                            // this.vehicleData.push(row)
                                            // }
                                            this.vehicleData = row;
                                            this.dataListLoading = false;
                                            this.isClose = true;
                                        } else if (
                                            istrue &&
                                            isOk === "已完成了等同课程，不需要再重复报名"
                                        ) {
                                            this.$confirm(
                                                this.$t("offering.resource.asignConfirmMsg"),
                                                "提示",
                                                {
                                                    confirmButtonText: "确定",
                                                    cancelButtonText: "取消",
                                                    type: "warning",
                                                }
                                            )
                                                .then(() => {
                                                    this.dataofferinginfo.availableBalance = Number(
                                                        (this.availableBalance - row.coursePrice).toFixed(3)
                                                    );
                                                    this.startVal = this.availableBalance;
                                                    this.endVal = this.dataofferinginfo.availableBalance;
                                                    this.vehicleData = row;
                                                    this.dataListLoading = false;
                                                    this.isClose = true;
                                                })
                                                .catch(() => {
                                                    this.$refs.singleTable.selection.forEach(function (
                                                        item,
                                                        index,
                                                        arr
                                                    ) {
                                                        console.info("******", item);
                                                        if (item === row) {
                                                            arr.splice(index, 1);
                                                        }
                                                    });
                                                    this.dataListLoading = false;
                                                    this.isClose = true;
                                                    // console.log('111111222222')
                                                });
                                        } else if (isOk === "已报名该时段的其他排期，由于时间冲突，操作失败。冲突排期如下"){
                                            this.$refs.singleTable.selection.forEach(function (
                                                item,
                                                index,
                                                arr
                                            ) {
                                                console.info("******", item);
                                                if (item === row) {
                                                    arr.splice(index, 1);
                                                }
                                            });
                                            this.dataListLoading = false;
                                            this.dialogVisible1 = true
                                            console.log(data.data["errData"])
                                            this.errorData =  data.data["errData"]
                                        } else {
                                            let count = 0;
                                            if (this.vehicleData.userId === row.userId) {
                                                count = count + this.vehicleData.coursePrice;
                                                this.vehicleData = {userNameCn: ""};
                                            }
                                            console.log(">>>>>>>>>>>>>>>" + count);
                                            //可用余额
                                            this.dataofferinginfo.availableBalance =
                                                this.dataofferinginfo.availableBalance + count;
                                            this.startVal =
                                                this.dataofferinginfo.availableBalance - count;
                                            this.endVal = this.dataofferinginfo.availableBalance;
                                            if (
                                                isOk !==
                                                "该学员不满足报名要求。请学员本人登录APP进入“课程报名”，点击“立即报名”，即可查看学习未完成情况。"
                                            ) {
                                                this.$message({
                                                    message: isOk,
                                                    type: "error",
                                                });
                                            }
                                            this.$refs.singleTable.selection.forEach(function (
                                                item,
                                                index,
                                                arr
                                            ) {
                                                console.info("******", item);
                                                if (item === row) {
                                                    arr.splice(index, 1);
                                                }
                                            });
                                            this.dataListLoading = false;
                                            this.isClose = true;
                                            // 显示子页面
                                            if (
                                                isOk ===
                                                "该学员不满足报名要求。请学员本人登录APP进入“课程报名”，点击“立即报名”，即可查看学习未完成情况。"
                                            ) {
                                                this.offeringConditionvalus = true;
                                                console.log(
                                                    "替换" +
                                                    this.dataofferinginfo.offeringId +
                                                    JSON.stringify(row)
                                                );
                                                this.$nextTick(() => {
                                                    this.$refs.offeringConditionreplace.inputvaluesDatelistreplace(
                                                        row,
                                                        this.dataofferinginfo.offeringId
                                                    );
                                                });
                                            }
                                        }
                                    })
                                    .catch(() => {
                                        this.dataListLoading = false;
                                        this.isClose = true;
                                    });
                            } else {
                                this.dataListLoading = false;
                                this.isClose = true;
                            }
                            // ********************************************************end20210628
                        })
                        .catch((err) => {
                            console.log(err)
                        });
                } else {
                    // 取消勾选
                    // for (let i in this.vehicleData) {
                    //   if (this.vehicleData[i].userId === row.userId) {
                    //     this.vehicleData.splice(i, 1)
                    //   }
                    // }
                    let count = 0;
                    if (this.vehicleData.userId === row.userId) {
                        count = count + this.vehicleData.coursePrice;
                        this.vehicleData = {userNameCn: ""};
                    }
                    console.log(">>>>>>>>>>>>>>>" + count);
                    //可用余额
                    this.dataofferinginfo.availableBalance =
                        this.dataofferinginfo.availableBalance + count;
                    this.startVal = this.dataofferinginfo.availableBalance - count;
                    this.endVal = this.dataofferinginfo.availableBalance;
                    this.dataListLoading = false;
                    this.isClose = true;
                }
            },
            // 勾选演员按钮
            // handleSelectionChange (selection, row) {
            //   console.info('selection-------->>', selection)
            //   // 判断当前点击的是打钩还是取消打钩 true 则是打勾
            //   if (this.$refs.singleTable.selection.length > 1) {
            //     this.$refs.singleTable.clearSelection();
            //     this.$refs.singleTable.toggleRowSelection(row);
            //   }
            //   let isSelected = this.isExistRow(selection, row, 'userId')
            //   if (isSelected) {
            //     // 勾选
            //     if (this.vehicleData !== undefined) {
            //       // 判断 vehicleData 是否有勾选的数据
            //       if (!this.isExistRow(this.vehicleData, row, 'userId')) {
            //         this.vehicleData = row
            //         this.userNameCn = this.vehicleData.userNameCn
            //       }
            //     }
            //   } else {
            //     this.vehicleData = ''
            //     // 取消勾选
            //     for (let i in this.vehicleData) {
            //       if (this.vehicleData[i].userId === row.userId) {
            //         this.vehicleData.splice(i, 1)
            //       }
            //     }
            //   }
            // },
            // 选择主要职位，维护已选项
            jobChange(val) {
                //this.jobCheckedAlready;
                this.positionChangeVal = val;
                if (val.length > this.positionChangeOld.length) {
                    let code = val[val.length - 1];
                    for (let index in this.jobCodeArr) {
                        if (code === this.jobCodeArr[index].code) {
                            this.positionSelectAlready.push(this.jobCodeArr[index]);
                        }
                    }
                }
                this.positionChangeOld = val;
            },
            // 点击已选项
            positionCheckChange(val) {
                if (val) {
                    // 已选
                    let jobCodeArr = JSON.parse(JSON.stringify(this.positionSelectAlready));
                    this.jobCodeArr = [];
                    this.positionChangeVal.forEach((item) => {
                        let entry = jobCodeArr.find((item1) => {
                            if (item1.code === item) {
                                return item1;
                            }
                        });
                        this.jobCodeArr.push(entry);
                    });
                } else {
                    this.queryPosition();
                }
            },
            // 获取集团
            getPosition() {
                this.$request
                    .get("/learning/offeringregiste/selectPosition")
                    .then((res, total, code, data) => {
                        this.groupList = data.data;
                    })
                    .catch((err) => {
                        console.log(err)
                    });
            },
            // 查询岗位信息
            queryPosition() {
                this.$request
                    .get("/talent/position/queryCommPosition", {})
                    .then((res, total, code, data) => {
                        this.jobCodeArr = data.data;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },
            /**
             * 将数值四舍五入(保留2位小数)后格式化成金额形式
             *
             * @param num 数值(Number或者String)
             * @return 金额格式的字符串,如'1,234,567.45'
             * @type String
             */
            formatMoney(num) {
                if (!num && num !== 0 && num !== "0") {
                    return "";
                }
                num = num.toString().replace(/\$|\,/g, "");
                if (isNaN(num)) {
                    num = "0";
                }
                let sign = num == (num = Math.abs(num));
                num = Math.floor(num * 100 + 0.50000000001);
                let cents = num % 100;
                num = Math.floor(num / 100).toString();
                if (cents < 10) {
                    cents = "0" + cents;
                }
                for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
                    num =
                        num.substring(0, num.length - (4 * i + 3)) +
                        "," +
                        num.substring(num.length - (4 * i + 3));
                }
                return (sign ? "" : "-") + num + "." + cents;
            },
        },
    };
</script>
<style>

    /* 隐藏网格的全选按钮 */
    .jySelectionAll
    > .el-table__fixed
    > .el-table__fixed-header-wrapper
    > .el-table__header
    > thead
    > tr
    > th
    > .cell
    > label {
        display: none;
    }

    /* 隐藏网格的全选按钮 */
    .jySelectionAll
    > .el-table__header-wrapper
    > .el-table__header
    > thead
    > tr
    > th
    > .cell
    > label {
        display: none !important;
    }
</style>
<style lang="scss" scoped>
    @import "../../../../../assets/scss/modules/trainingCharge.scss";
    .longText {
        overflow: hidden;     /*设置超出的部分进行影藏*/
        text-overflow: ellipsis;     /*设置超出部分使用省略号*/
        white-space:nowrap ;    /*设置为单行*/
        width: 160px !important;
        display: inline-block;
        margin: 0 !important;
    }
    .dialog-footer {
        margin: 10px;
        padding-bottom: 20px !important;
    }

    .el-input {
        border: 0px;
    }

     .el-dialog__header {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding: 20px 24px;

        .el-dialog__header_cus {
            height: 22px;
            line-height: 22px;
            color: rgba(37, 38, 40, 100);
            font-size: 16px;
            position: relative;
            padding-left: 11px;

            &::before {
                content: "";
                width: 3px;
                height: 14px;
                border-radius: 1px;
                display: inline-block;
                background-color: rgba(28, 105, 212, 1);
                position: absolute;
                top: 4px;
                left: 0px;
            }
        }
    }

    .card-panel-num {
        color: rgba(28, 105, 212, 100);
        font-size: 18px;
        text-align: left;
        font-family: PingFang-SC-Bold, sans-serif;
    }

     .el-dialog__body {
        padding: 24px !important;

        .el-form-item__label {
            color: rgba(153, 154, 156, 100);
            height: 20px;
            line-height: 20px !important;
            font-size: 14px;
            text-align: left;
            font-family: PingFangSC-Regular, sans-serif;
            min-width: 70px;
        }

        .el-input__inner {
            height: 32px !important;
        }

        .el-form-item {
            width: 100% !important;
            display: flex;
            align-items: center;
            margin-bottom: 0px !important;

            .el-form-item__content {
                height: 44px !important;
                line-height: 44px !important;
            }
        }

        .primary-btn {
            margin-top: 6px;
            color: rgba(24, 93, 189, 100) !important;
            background-color: rgba(28, 105, 212, 0.05) !important;
            border-color: rgba(28, 105, 212, 0.05) !important;
            margin-left: 16px;

            &:hover {
                background-color: rgba(28, 105, 212, 0.2) !important;
            }
        }

        .info-btn {
            margin-top: 6px;

            // font-family: PingFangSC-Regular, sans-serif;
            color: rgba(37, 38, 40, 100) !important;
            background-color: rgba(37, 38, 40, 0.05) !important;
            border-color: rgba(37, 38, 40, 0.05) !important;

            &:hover {
                background-color: rgba(37, 38, 40, 0.2) !important;
            }
        }
    }

     .el-pagination.is-background .btn-next,
     .el-pagination.is-background .btn-prev,
     .el-pagination.is-background .el-pager li {
        background-color: white !important;
        border: 1px solid #f4f4f5 !important;
    }

     .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #409EFF !important;
        color: #FFF !important;
    }

    //replaceDialog
    .replaceDialog {
         .el-dialog__header {
            background: #F2F4F5;
            padding: 14px 24px !important;
            border-bottom: 0px !important;
        }

        .assign-dialog-tip {
            height: 18px;
            line-height: 18px;
            color: rgba(153, 154, 156, 100);
            font-size: 12px;
            text-align: left;
            font-family: PingFangSC-Regular, sans-serif;
            margin-bottom: 10px;

            > span {
                color: #000;
            }
        }

         .el-tag {
            display: inline-block;
            padding: 0px !important;;
            // height: 20px;
            color: rgba(37, 38, 40, 100);
            font-size: 14px;
            text-align: left;
            font-family: PingFangSC-Medium, sans-serif;
            border: 0;
            background: white;
            margin: -6px 0px 18px 0px;

            .tag-reduction {
                text-align: center;
                display: inline-block;
                width: 36px;
                height: 18px;
                line-height: 18px;
                color: rgb(28, 105, 212);
                border-radius: 2px;
                background-color: rgba(28, 105, 212, .1);
                font-family: PingFangSC-Regular, sans-serif;
            }

            .el-tag__close {
                .el-icon-close {
                    &::before {
                        margin-top: 1px;
                    }
                }
            }
        }
    }

     .el-button span {
        font-weight: 500 !important;
    }

    // show-msg-container
     .show-msg-container {
        border-radius: 4px;
        background-color: rgba(232, 240, 250, 0.5);
        padding: 16px;

        .msg-label {
            height: 22px;
            line-height: 22px;
            color: rgba(153, 154, 156, 100);
            font-size: 12px;
            text-align: right;
            font-family: PingFangSC-Regular, sans-serif;
        }

        .msg-value {
            height: 22px;
            line-height: 22px;
            color: rgba(37, 38, 40, 100);
            font-size: 14px;
            text-align: left;
            font-family: PingFangSC-Regular, sans-serif;

            &.msg-spe-value {
                color: rgba(28, 105, 212, 100);
                font-family: PingFangSC-Semibold, sans-serif;
            }
        }
    }
    .el-table--enable-row-transition  .el-table__body td {
        border-right: 1px solid #EBEEF5 !important;
    }
     .el-table th {
        background-color: #EBEEF5 !important;
        border-right: 0 !important;
    }
    .one {
         .el-dialog__header {
            border-bottom: 0px !important;
        }
    }
</style>
